module.exports = {
  copyright: 'Copyright ©2020 xID Inc. All Rights Reserved.',
  terms_and_condition: 'プライバシーポリシー',
  privacy_policy: '利用規約',
};
